module.exports = __webpack_public_path__ + "static/media/texture_03.78b6e303.png";